import { FontMetadataDto, FontStyleDto } from "../font.ts";

// Weights and styles are derived from `variants` instead of being stored
// alongside them, since a family can be italic-only for some weights and a
// flat list of styles would overstate what is actually available.
export function getFontWeights(metadata: FontMetadataDto): number[] {
  return [...new Set(metadata.variants.map((variant) => variant.weight))].sort(
    (a, b) => a - b,
  );
}

// Styles available for the given weight, or across every variant when the
// weight is omitted. Ordered by the enum's declaration order.
export function getFontStyles(
  metadata: FontMetadataDto,
  weight?: number | null,
): FontStyleDto[] {
  const available = new Set(
    metadata.variants
      .filter((variant) => weight == null || variant.weight === weight)
      .map((variant) => variant.style),
  );

  return FontStyleDto.options.filter((style) => available.has(style));
}
